var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpSquare = function SvgUpSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#up-square_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    filter: "url(#up-square_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CEEAF8",
    fillRule: "evenodd",
    d: "M3.79 18.15c-.915-1.26-.915-3.056-.915-6.65 0-3.593 0-5.39.915-6.65a4.8 4.8 0 0 1 1.06-1.06c1.26-.915 3.057-.915 6.65-.915s5.39 0 6.65.915c.407.296.764.653 1.06 1.06.915 1.26.915 3.057.915 6.65s0 5.39-.915 6.65a4.8 4.8 0 0 1-1.06 1.06c-1.26.915-3.056.915-6.65.915-3.593 0-5.39 0-6.65-.915a4.8 4.8 0 0 1-1.06-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#up-square_svg__c)",
    strokeLinecap: "round",
    d: "M3.79 18.15c-.915-1.26-.915-3.056-.915-6.65 0-3.593 0-5.39.915-6.65a4.8 4.8 0 0 1 1.06-1.06c1.26-.915 3.057-.915 6.65-.915s5.39 0 6.65.915c.407.296.764.653 1.06 1.06.915 1.26.915 3.057.915 6.65s0 5.39-.915 6.65a4.8 4.8 0 0 1-1.06 1.06c-1.26.915-3.056.915-6.65.915-3.593 0-5.39 0-6.65-.915a4.8 4.8 0 0 1-1.06-1.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#up-square_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#up-square_svg__e)",
    fillRule: "evenodd",
    d: "M16.802 12.91a.719.719 0 0 1-1.02 1.013l-1.675-1.69c-.68-.686-1.148-1.156-1.544-1.474-.385-.31-.632-.415-.854-.444a1.7 1.7 0 0 0-.418 0c-.222.029-.47.135-.854.444-.396.318-.864.788-1.544 1.474l-1.674 1.69a.719.719 0 1 1-1.021-1.012l1.705-1.72c.642-.648 1.166-1.178 1.634-1.553.486-.39.98-.673 1.572-.749q.391-.05.782 0c.592.076 1.086.359 1.572.749.468.376.993.905 1.635 1.553z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "up-square_svg__c",
    x1: 2.875,
    x2: 20.134,
    y1: 20.125,
    y2: 2.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "up-square_svg__e",
    x1: 11.593,
    x2: 17.328,
    y1: 7.742,
    y2: 19.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "up-square_svg__b",
    width: 66.25,
    height: 66.25,
    x: -21.625,
    y: -21.625,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_4674"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1_4674",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "up-square_svg__d",
    width: 27.021,
    height: 21.271,
    x: 2.99,
    y: 5.865,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4674"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1_4674",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "up-square_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23v23H0z"
  })))));
};
export { SvgUpSquare as ReactComponent };